import React from "react";

const GlobalContext = React.createContext({});

export const GlobalContextProvider = GlobalContext.Provider;

export default GlobalContext;